import type { Action } from "../state/actions.ts";
import { useRef } from "preact/hooks";
import { TelegramDocumentSchema } from "../serialization/schema.ts";

interface Props {
  dispatch: (action: Action) => void;
}

export function ExportBar({ dispatch }: Props) {
  const fileRef = useRef<HTMLInputElement>(null);

  const onImport = async (e: Event) => {
    const file = (e.target as HTMLInputElement).files?.[0];
    if (!file) return;
    try {
      const text = await file.text();
      const parsed = TelegramDocumentSchema.safeParse(JSON.parse(text));
      if (!parsed.success) return;
      dispatch({ type: "IMPORT_JSON", document: parsed.data });
    } catch {
      // invalid file, ignore
    }
    if (fileRef.current) fileRef.current.value = "";
  };

  return (
    <div class="flex gap-2">
      <button
        class="px-3 py-1.5 text-sm rounded-lg shadow-sm"
        style={{ background: "#FFF8E7", border: "1px solid #D4B078", color: "#5D4E37" }}
        onClick={() => dispatch({ type: "EXPORT_PNG" })}
      >
        Export PNG
      </button>
      <button
        class="px-3 py-1.5 text-sm rounded-lg shadow-sm"
        style={{ background: "#FFF8E7", border: "1px solid #D4B078", color: "#5D4E37" }}
        onClick={() => dispatch({ type: "EXPORT_JSON" })}
      >
        Export JSON
      </button>
      <button
        class="px-3 py-1.5 text-sm rounded-lg shadow-sm"
        style={{ background: "#FFF8E7", border: "1px solid #D4B078", color: "#5D4E37" }}
        onClick={() => fileRef.current?.click()}
      >
        Import JSON
      </button>
      <input ref={fileRef} type="file" accept=".json" class="hidden" onChange={onImport} />
    </div>
  );
}
